import debounce from 'lodash/debounce';
import * as React from 'react';
import { BreakpointContext } from '../../contexts/BreakpointContext';
export var BreakpointProvider = function (_a) {
    var breakpoints = _a.breakpoints, children = _a.children;
    var _b = React.useState(0), currentBreakpoint = _b[0], setCurrentBreakpoint = _b[1];
    React.useEffect(function () {
        if (!breakpoints || !breakpoints.length) {
            return;
        }
        var handleResize = function () {
            var clientWidth = window.innerWidth;
            var breakpointIndex = breakpoints.findIndex(function (breakpoint) { return clientWidth < breakpoint; });
            var currentBreakpoint = breakpointIndex >= 0 ? breakpointIndex : breakpoints.length - 1;
            setCurrentBreakpoint(currentBreakpoint);
        };
        var debouncedResize = debounce(handleResize, 80);
        handleResize();
        window.addEventListener('resize', debouncedResize, { passive: false });
        return function () {
            window.removeEventListener('resize', debouncedResize);
        };
    }, [breakpoints]);
    return (React.createElement(BreakpointContext.Provider, { value: { currentBreakpoint: currentBreakpoint } }, children));
};
BreakpointProvider.displayName = 'BreakpointProvider';
